
export default function(possibility = 50) {
    return Math.random() < (possibility / 100);
}